module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/bath-c60a2fac3ddb63c9b6bb0cadd792b4ee.webp";